<template>
  <div class="equity-change">
    <RowInfo label="总流通股本">{{ $digitjs(basicData.floatShares).unit('股').convert() }}</RowInfo>
    <!-- <RowInfo label="港股流通股">{{ $digitjs(basicData.floatShares).unit('股').convert() }}</RowInfo> -->
    <VueEcharts :option="option" />
    <ColTable :data="holdChangeData" class="col-table--equity">
      <ColTableColumn prop="changeDate" label="变动日期"></ColTableColumn>
      <ColTableColumn prop="issuedShare" label="已发行普通股(股)">
        <template slot-scope="{ row }">{{ $digitjs(row.issuedShare).convert() }}</template>
      </ColTableColumn>
      <ColTableColumn prop="issuedShareChange" label="普通股变动(股)">
        <template slot-scope="{ row }">{{ $digitjs(row.issuedShareChange).convert() }}</template>
      </ColTableColumn>
      <ColTableColumn prop="changeReason" label="变动原因"></ColTableColumn>
    </ColTable>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
import VueEcharts from '@/components/common/VueEcharts.vue'
import { i18nTranslateInit } from '@/utils/utility-lang'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { RowInfo, VueEcharts },
  inject: ['theme'],
  data() {
    return {
      basicData: {},
      holdChangeData: [],
      useOpenCC: i18nTranslateInit.useOpenCC
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    option() {
      return {
        grid: {
          top: 40,
          bottom: 0,
          left: 0,
          right: 0,
          containLabel: true
        },
        legend: {
          left: 0,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: this.theme['--font-color-2']
          },
          icon: 'rect'
        },
        xAxis: [
          {
            type: 'category',
            inverse: true,
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              fontSize: postcssPatch(9),
              color: this.theme['--font-color-3']
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitNumber: 2,
            splitLine: {
              lineStyle: {
                color: this.theme['--border-color-1']
              }
            },
            axisLabel: {
              color: this.theme['--font-color-3'],
              formatter: (value) => {
                return this.$digitjs(value).convert(0)
              }
            }
          }
        ],
        dataset: {
          source: this.holdChangeData
        },
        series: [
          {
            name: this.useOpenCC('普通股变动(股)'),
            type: 'bar',
            barWidth: 22,
            encode: {
              x: 'changeDate',
              y: 'issuedShareChange'
            },
            itemStyle: {
              color: '#FF9933'
            },
            label: {
              color: '#fff'
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.getSummaryBasicData()
    this.getHoldChangeData()
  },
  methods: {
    async getSummaryBasicData() {
      const res = await this.$post(this.$api.f10.hk + '/summary/basic', {
        symbol: this.symbol
      })
      const { totalShares, floatShares } = res.data?.[0] ?? {}
      this.basicData = { totalShares, floatShares }
    },
    async getHoldChangeData() {
      const res = await this.$post(this.$api.f10.hk + '/summary/hold-change', {
        type: 'S',
        pageNum: 1,
        pageSize: 5,
        symbol: this.symbol
      })
      this.holdChangeData = res.data ?? []
    }
  }
}
</script>

<style lang="scss" scoped>
.equity-change {
  margin-top: 10px;

  .col-table--equity {
    --col-table-title-width: 120px;
  }
  .echarts-container {
    margin: 30px 0 15px;
  }
}
</style>
